import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var SvgChat = function SvgChat(_a) {
  var title = _a.title,
    desc = _a.desc,
    titleId = _a.titleId,
    descId = _a.descId,
    props = __rest(_a, ["title", "desc", "titleId", "descId"]);
  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  props['aria-labelledby'] = ariaLabelledBy;
  return jsxs("svg", __assign({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !!ariaLabelledBy
  }, props, {
    children: [!!title && jsx("title", __assign({
      id: titleId
    }, {
      children: title
    }), void 0), !!desc && jsx("desc", __assign({
      id: descId
    }, {
      children: desc
    }), void 0), jsx("rect", {
      width: 32,
      height: 32,
      fill: "white"
    }, void 0), jsx("path", {
      d: "M6 16C6 10.4772 10.4772 6 16 6V6C21.5228 6 26 10.4772 26 16V16C26 21.5228 21.5228 26 16 26H6.39216C6.17557 26 6 25.8244 6 25.6078V16Z",
      stroke: "currentColor",
      strokeWidth: 1.5
    }, void 0), jsx("circle", {
      cx: 10.5,
      cy: 16.5,
      r: 1.5,
      fill: "currentColor"
    }, void 0), jsx("circle", {
      cx: 15.5,
      cy: 16.5,
      r: 1.5,
      fill: "currentColor"
    }, void 0), jsx("circle", {
      cx: 20.5,
      cy: 16.5,
      r: 1.5,
      fill: "currentColor"
    }, void 0)]
  }), void 0);
};

export { SvgChat as default };
